import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const STATUSES = ["new", "needs_details", "quoted", "accepted", "awaiting_payment", "in_production", "ready", "shipped", "complete", "cancelled"];

export default function CustomOrders() {
  const [orders, setOrders] = useState(null);

  const load = () => api("/admin/custom-orders").then(setOrders).catch(() => setOrders([]));
  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try {
      await api(`/admin/custom-orders/${id}`, { method: "PATCH", body: patch });
      toast("Custom order updated");
      load();
    } catch (e) { toast.error(e.message); }
  };

  if (!orders) return <p className="text-muted font-bold">Fetching requests…</p>;

  return (
    <div data-testid="admin-custom-orders">
      <h1 className="font-display font-semibold text-2xl">Custom Orders</h1>
      {orders.length === 0 ? <p className="text-muted font-semibold mt-6">No custom requests yet.</p> : (
        <div className="mt-6 space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-3xl border border-candy-soft/70 p-4" data-testid={`admin-custom-${o.ref}`}>
              <div className="flex flex-wrap items-center gap-3">
                <span className="font-display font-semibold">{o.ref}</span>
                <span className="text-sm font-bold text-muted">{o.name} · {o.email}{o.phone ? ` · ${o.phone}` : ""}</span>
                <select data-testid={`admin-custom-status-${o.ref}`} value={o.status} onChange={(e) => update(o.id, { status: e.target.value })} className="ml-auto px-3 py-1.5 rounded-full bg-candy-mist border border-candy-soft text-xs font-bold">
                  {STATUSES.map((s) => <option key={s} value={s} className="capitalize">{s.replace(/_/g, " ")}</option>)}
                </select>
              </div>
              <div className="mt-3 text-sm text-ink/70 font-semibold grid sm:grid-cols-2 gap-2">
                <p><strong>Item:</strong> {o.item_type} × {o.quantity}</p>
                {o.colors && <p><strong>Colors:</strong> {o.colors}</p>}
                {o.dimensions && <p><strong>Size:</strong> {o.dimensions}</p>}
                {o.budget && <p><strong>Budget:</strong> {o.budget}</p>}
                {o.requested_date && <p><strong>Needed by:</strong> {o.requested_date}</p>}
                {o.gift && <p><strong>Gift wrap:</strong> yes</p>}
                {o.inspiration && <p className="sm:col-span-2"><strong>Inspiration:</strong> {o.inspiration}</p>}
                {o.notes && <p className="sm:col-span-2"><strong>Notes:</strong> {o.notes}</p>}
              </div>
              <label className="block mt-3">
                <span className="text-xs font-bold text-muted uppercase">Private notes (never shown to customers)</span>
                <input data-testid={`admin-custom-notes-${o.ref}`} defaultValue={o.internal_notes} onBlur={(e) => e.target.value !== (o.internal_notes || "") && update(o.id, { status: o.status, internal_notes: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-xl bg-candy-mist border border-candy-soft text-sm font-semibold" />
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
